export const GizlilikSozlesmesi = () => {
  return (
    <div className="container mx-auto px-4 py-16 mt-16">
      <div className="max-w-4xl mx-auto prose prose-lg">
        <h1 className="text-3xl font-bold mb-8">GİZLİLİK POLİTİKASI</h1>
        
        <p className="mb-6">
          Kampüs Mentörlük tarafından verilen mentörlük hizmetleri ve ürünler firmamıza aittir ve firmamız tarafından işletilir. 
          Firmamız, çeşitli amaçlarla kişisel veriler toplayabilir. Aşağıda, toplanan kişisel verilerin nasıl ve ne şekilde toplandığı, 
          bu verilerin nasıl ve ne şekilde korunduğu belirtilmiştir.
        </p>

        <p className="mb-6">
          Üyelik veya websitemiz üzerindeki çeşitli form ve anketlerin doldurulması suretiyle üyelerin kendileriyle ilgili bir takım 
          kişisel bilgileri (isim-soy isim, öğrenci bilgileri, telefon, adres veya e-posta adresleri gibi) işyerimiz tarafından işin 
          doğası gereği toplanmaktadır.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">BİLDİRİMLER VE PAZARLAMA</h2>
        <p className="mb-6">
          Firmamız bazı dönemlerde öğrencilerine ve üyelerine kampanya bilgileri, yeni hizmetler hakkında bilgiler, promosyon teklifleri 
          gönderebilir. Üyelerimiz bu gibi bilgileri alıp almama konusunda her türlü seçimi üye olurken yapabilir, sonrasında üye girişi 
          yaptıktan sonra hesap bilgileri bölümünden bu seçimi değiştirebilir ya da kendisine gelen bilgilendirme iletisindeki linkle 
          bildirim yapabilir.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">ÖDEME GÜVENLİĞİ</h2>
        <p className="mb-6">
          Firmamız, alışveriş yapan kart sahiplerinin güvenliğini ilk planda tutmaktadır. Ödeme bilgileriniz hiçbir şekilde sistemimizde 
          saklanmamaktadır. İşlemler sürecine girdiğinizde güvenli bir sitede olduğunuzu anlamak için dikkat etmeniz gereken iki şey 
          vardır. Bunlardan biri tarayıcınızın en alt satırında bulunan bir anahtar ya da kilit simgesidir. Bu güvenli bir internet 
          sayfasında olduğunuzu gösterir ve her türlü bilgileriniz şifrelenerek korunur.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">GİZLİLİK POLİTİKASI ŞARTLARI</h2>
        <p className="mb-6">
          Firmamız, gizli bilgileri kesinlikle özel ve gizli tutmayı, bunu bir sır saklama yükümü olarak addetmeyi ve gizliliğin 
          sağlanması ve sürdürülmesi, gizli bilginin tamamının veya herhangi bir kısmının kamu alanına girmesini veya yetkisiz 
          kullanımını veya üçüncü bir kişiye ifşasını önlemek için gerekli tüm tedbirleri almayı ve gerekli özeni göstermeyi taahhüt 
          etmektedir.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">E-POSTA GÜVENLİĞİ</h2>
        <p className="mb-6">
          Firmamızın Müşteri Hizmetleri'ne, herhangi bir hizmet alımınızla ilgili olarak göndereceğiniz e-postalarda, asla kredi kartı 
          numaranızı veya şifrelerinizi yazmayınız. E-postalarda yer alan bilgiler üçüncü şahıslar tarafından görülebilir. Firmamız 
          e-postalarınızdan aktarılan bilgilerin güvenliğini hiçbir koşulda garanti edemez.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">İLETİŞİM BİLGİLERİ</h2>
        <p className="mb-6">
          Firmamıza ait aşağıdaki iletişim bilgilerinden ulaşabilirsiniz:
        </p>
        <p>
          E-posta: info@kampusmentorluk.com<br />
          Tel: +90 541 592 1450<br />
          Web: www.kampusmentorluk.com
        </p>

        <p className="mt-8">Saygılarımızla;</p>
        <p className="font-semibold">Kampüs Mentörlük</p>
      </div>
    </div>
  );
}; 